import Vue from 'vue'
import VueRouter from 'vue-router'
import { isUserLoggedIn } from '@/auth/utils'
import { canNavigate } from '@/libs/acl/routeProtection'

Vue.use(VueRouter)

const router = new VueRouter({
  mode: 'history',
  base: process.env.BASE_URL,
  scrollBehavior() {
    return {
      x: 0,
      y: 0,
    }
  },
  routes: [
    // {
    //   path: '/',
    //   name: 'home',
    //   component: () => import('@/views/overview/Overview.vue'),
    //   meta: {
    //     pageTitle: 'Home',
    //     breadcrumb: [
    //       {
    //         text: 'Home',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/',
      name: 'marketoverview',
      component: () => import('@/views/cis-brandindex/BrandIndex.vue'),
      meta: {
        pageTitle: 'MarketOverview',
        breadcrumb: [
          {
            text: 'MarketOverview',
            active: true,
          },
        ],
      },
    },
    {
      path: '/competition',
      name: 'competition',
      component: () => import('@/views/cis-competition/Competition.vue'),
      meta: {
        pageTitle: 'Competition',
        breadcrumb: [
          {
            text: 'Competition',
            active: true,
          },
        ],
      },
    },
    {
      path: '/brandpin',
      name: 'brandpin',
      component: () => import('@/views/cis-brandpin/BrandPin.vue'),
      meta: {
        pageTitle: 'BrandPin',
        breadcrumb: [
          {
            text: 'BrandPin',
            active: true,
          },
        ],
      },
    },
    {
      path: '/trendkeyword',
      name: 'trendkeyword',
      component: () => import('@/views/cis-trendkeyword/TrendKeyword.vue'),
      meta: {
        pageTitle: 'TrendKeyword',
        breadcrumb: [
          {
            text: 'TrendKeyword',
            active: true,
          },
        ],
      },
    },
    {
      path: '/insight',
      name: 'insight',
      component: () => import('@/views/cis-insight/Insight.vue'),
      meta: {
        pageTitle: 'Insight',
        breadcrumb: [
          {
            text: 'Insight',
            active: true,
          },
        ],
      },
    },
    {
      path: '/tracking',
      name: 'tracking',
      component: () => import('@/views/cis-tracking/Tracking.vue'),
      meta: {
        pageTitle: 'Tracking',
        breadcrumb: [
          {
            text: 'Tracking',
            active: true,
          },
        ],
      },
    },
    {
      path: '/brandnametag',
      name: 'brandnametag',
      component: () => import('@/views/cis-brandnametag/BrandNameTag.vue'),
      meta: {
        pageTitle: 'BrandNameTag',
        breadcrumb: [
          {
            text: 'BrandNameTag',
            active: true,
          },
        ],
      },
    },
    {
      path: '/searchtag',
      name: 'searchtag',
      component: () => import('@/views/cis-searchtag/SearchTag.vue'),
      meta: {
        pageTitle: 'SearchTag',
        breadcrumb: [
          {
            text: 'SearchTag',
            active: true,
          },
        ],
      },
    },
    // {
    //   path: '/campaigns/:id',
    //   name: 'campaign-detail',
    //   component: () => import('@/views/campaigns/detail/CampaignDetail.vue'),
    //   props: (route) => ({ searchDates: route.query.searchDates }),
    //   meta: {
    //     pageTitle: 'Campaign Home',
    //     breadcrumb: [
    //       {
    //         text: 'Campaign Home',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/ad-groups/:id',
    //   name: 'ad-group-detail',
    //   component: () => import('@/views/ad-groups/detail/AdGroupDetail.vue'),
    //   props: (route) => ({ searchDates: route.query.searchDates }),
    //   beforeEnter(to, from, next) {
    //     const path = `/campaigns/${to.params.campaignId}`;
    //     to.meta.breadcrumb[0] = {
    //       text: 'Campaign Home',
    //       to: path
    //     }
    //     next()
    //   },
    //   meta: {
    //     pageTitle: 'Ad Group Home',
    //     breadcrumb: [
    //       {
    //         text: 'Campaign Home',
    //       },
    //       {
    //         text: 'Ad Group Home',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/creative-groups',
    //   name: 'creative-groups',
    //   component: () => import('@/views/creative-groups/list/CreativeGroupList.vue'),
    //   meta: {
    //     pageTitle: 'Creative Groups',
    //     breadcrumb: [
    //       {
    //         text: 'Creative Groups',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/creative-groups/:id',
    //   name: 'creative-group-detail',
    //   component: () => import('@/views/creative-groups/detail/CreativeGroupDetail.vue'),
    //   meta: {
    //     pageTitle: 'Creative Groups',
    //     breadcrumb: [
    //       {
    //         text: 'Creative Groups',
    //         to: '/creative-groups',
    //       },
    //       {
    //         text: 'Creative Group Home',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/report',
    //   name: 'report',
    //   component: () => import('@/views/report/Report.vue'),
    //   meta: {
    //     pageTitle: null,
    //     breadcrumb: [
    //       {
    //         text: 'Report (Max 10K rows)',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/custom-targets',
    //   name: 'custom-targets',
    //   component: () => import('@/views/custom-targets/list/CustomTargetList.vue'),
    //   meta: {
    //     pageTitle: null,
    //     breadcrumb: [
    //       {
    //         text: 'Targets',
    //       },
    //       {
    //         text: 'Custom Targets',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/custom-targets/:id',
    //   name: 'custom-target-detail',
    //   component: () => import('@/views/custom-targets/detail/CustomTargetDetail.vue'),
    //   meta: {
    //     pageTitle: 'Custom Targets',
    //     breadcrumb: [
    //       {
    //         text: 'Custom Targets',
    //         to: '/custom-targets',
    //       },
    //       {
    //         text: 'Custom Target Detail',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/tracking',
    //   name: 'tracking',
    //   component: () => import('@/views/tracking/list/TrackingList.vue'),
    //   meta: {
    //     pageTitle: 'Tracking',
    //     breadcrumb: [
    //       {
    //         text: 'Tracking',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    // {
    //   path: '/tracking/:sq',
    //   name: 'tracking-link-detail',
    //   component: () => import('@/views/tracking/detail/trackingDetail.vue'),
    //   meta: {
    //     pageTitle: 'Tracking Link Detail',
    //     breadcrumb: [
    //       {
    //         text: 'Tracking',
    //         to: '/tracking',
    //       },
    //       {
    //         text: 'Tracking Link Detail',
    //         active: true,
    //       },
    //     ],
    //   },
    // },
    {
      path: '/account-info',
      name: 'account-info',
      component: () => import('@/views/settings/AdAccountInfo.vue'),
      meta: {
        pageTitle: 'Ad Account Info',
        breadcrumb: [
          {
            text: 'Setting',
          },
          {
            text: 'Ad Account',
          },
          {
            text: 'Ad Account Info',
            active: true,
          },
        ],
      },
    },
    {
      path: '/cis-account',
      name: 'cis-account',
      component: () => import('@/views/cis-settings/cis-account'),
      meta: {
        pageTitle: 'CIS Account',
        breadcrumb: [
          {
            text: 'Setting',
          },
          {
            text: 'CIS Account',
          }
        ],
      },
    },
    {
      path: '/cis-prices',
      name: 'cis-prices',
      component: () => import('@/views/cis-settings/cis-prices'),
      meta: {
        pageTitle: 'CIS Prices',
        breadcrumb: [
          {
            text: 'Setting',
          },
          {
            text: 'CIS Prices',
          }
        ],
      },
    },
    {
      path: '/cis-users',
      name: 'cis-users',
      component: () => import('@/views/cis-settings/cis-users'),
      meta: {
        pageTitle: 'CIS Users',
        breadcrumb: [
          {
            text: 'Setting',
          },
          {
            text: 'CIS Users',
          }
        ],
      },
    },
    {
      path: '/cis-seeds',
      name: 'cis-seeds',
      component: () => import('@/views/cis-settings/cis-seeds'),
      meta: {
        pageTitle: 'CIS Seeds',
        breadcrumb: [
          {
            text: 'Seeds',
          },
          {
            text: 'CIS Seeds',
          }
        ],
      },
    },
    {
      path: '/cis-keywords',
      name: 'cis-keywords',
      component: () => import('@/views/cis-settings/cis-keywords'),
      meta: {
        pageTitle: 'CIS Keywords',
        breadcrumb: [
          {
            text: 'Keywords',
          },
          {
            text: 'CIS Keywords',
          }
        ],
      },
    },
    {
      path: '/cis-synonyms',
      name: 'cis-synonyms',
      component: () => import('@/views/cis-settings/cis-synonyms'),
      meta: {
        pageTitle: 'CIS Synonyms',
        breadcrumb: [
          {
            text: 'Synonyms',
          },
          {
            text: 'CIS Synonyms',
          }
        ],
      },
    },
    {
      path: '/cis-uncategorized',
      name: 'cis-uncategorized',
      component: () => import('@/views/cis-settings/cis-uncategorized'),
      meta: {
        pageTitle: 'CIS Uncategorized',
        breadcrumb: [
          {
            text: 'Uncategorized',
          },
          {
            text: 'CIS Uncategorized',
          }
        ],
      },
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('@/views/authentication/Login.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/intro',
      name: 'intro',
      component: () => import('@/views/authentication/Intro.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/forgot-password',
      name: 'forgot-password',
      component: () => import('@/views/authentication/ForgotPassword.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
      },
    },
    {
      path: '/page-not-found',
      name: 'page-not-found',
      component: () => import('@/views/error/Error404.vue'),
      meta: {
        layout: 'full',
      },
    },
    {
      path: '*',
      redirect: 'page-not-found',
    },
    {
      path: '/vote2025t',
      name: 'vote2025t',
      component: () => import('@/views/vote2025/voteTrend.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/vote2025e',
      name: 'vote2025e',
      component: () => import('@/views/vote2025/voteEmotion.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/vote2025r',
      name: 'vote2025r',
      component: () => import('@/views/vote2025/voteRelation.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/vote2026t',
      name: 'vote2026t',
      component: () => import('@/views/vote2026/voteTrend.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },
    {
      path: '/vote2026r',
      name: 'vote2026r',
      component: () => import('@/views/vote2026/voteRelation.vue'),
      meta: {
        layout: 'full',
        resource: 'Auth',
        redirectIfLoggedIn: true,
      },
    },


  ],
})

router.beforeEach((to, _, next) => {
  const isLoggedIn = isUserLoggedIn()

  if (!canNavigate(to)) {
    // Redirect to log in if not logged in
    if (!isLoggedIn && to.name !== 'login') return next({ name: 'intro' })
  }

  // Redirect if logged in
  // const userData = getUserData()
  // next(getHomeRouteForLoggedInUser(userData ? userData.role : null))

  return next()
})

// ? For splash screen
// Remove afterEach hook if you are not using splash screen
router.afterEach(() => {
  // Remove initial loading
  const appLoading = document.getElementById('loading-bg')
  if (appLoading) {
    appLoading.style.display = 'none'
  }
})

export default router
